<template>
  <div class="notifications-bar" v-if="showStatusBar && content" :class="content.class">
    <img class="inline-block notifications-icon" :src="content.icon">

    <span>
      {{ content.message }}
    </span>

    <span v-if="showLink">
      <a id="notifications-Verification-account-action" href="/settings/account?ref=status-bar&section=verification" class="account-details-link shadow-none" @click.prevent="goToVerification">
        Verification Section
      </a>
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    account () {
      return this.$store.getters['authentication/activeAccount']
    },
    showLink () {
      return true
    },
    content () {
      if (!this.showStatusBar) {
        return null
      }

      const totalFund = this.account.total_fund

      const isVerified  = this.account.verification_status === 'verified'

      if (!isVerified && totalFund === 0 && this.account.campaigns_count === 0) {
        return {
          class: 'info',
          message: this.$t('You can spend up to $1000. To add more funds, you need to complete your account details by filling in the'),
          icon: require('@/assets/images/status-bar/info.svg')
        }
      }

      return null
    },
    showStatusBar () {
      if (!this.account.verified_at) {
        return true
      }

      const today = new Date()

      const accountVerficationTime = new Date(this.account.verified_at)
      accountVerficationTime.setDate(accountVerficationTime.getDate() + 1)

      if (accountVerficationTime.getTime() > today.getTime()) {
        return true
      }

      return false
    }
  },
  methods: {
    goToVerification () {
      const route = {
        name: 'account',
        query: {
          ref: 'status-bar',
          section: 'verification'
        }
      }

      if (this.$route.name !== route.name) {
        this.$router.push(route)
      }

      this.$root.$emit('verification-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
  .notifications-bar {
    color: rgba(0, 0, 0, 0.65);
    border-radius: 0.5rem;
    text-align: left;
    padding: 15px 20px;
    margin-bottom: 30px;

    .account-details-link {
      color: rgba(0, 0, 0, 0.65) !important;
      font-weight: bold !important;
      padding: 0 !important;
      text-decoration: underline !important;
    }
  }

  .info {
    border: 1px solid #0092d7;
    background-color: #e6f7ff;
  }

  .warning {
    border: 1px solid #f2af03;
    background-color: #f9f4e7;
  }

  .danger {
    border: 1px solid #ffa39e;
    background-color: #fff1f0;
  }

  .success {
    border: 1px solid #21ba45;
    background-color: #eefaf0;
  }

  .notifications-icon {
    position: relative;
    top: 5px;
    margin-right: 12px;
  }
</style>
